import { useCallback, useEffect, useState } from "react";
// import { useValueEnhancer } from "use-value-enhancer";
import { RemoI18n, RemoI18nLanguages, RemoI18nTFunction } from "./remo-i18n";
import { ReadonlyVal } from "value-enhancer";

export function useLanguage(): RemoI18nLanguages {
    const [remoI18n] = useState(RemoI18n.getInstance);
    return useValueEnhancer(remoI18n.$Val.language$);
}

const useValueEnhancer = <TValue = any, TMeta = any>(val: ReadonlyVal<TValue, TMeta>): TValue => {
    const [value, setValue] = useState(val.value);
    useEffect(() => val.subscribe(setValue), [val]);
    return value;
};

export function useTranslate(): RemoI18nTFunction {
    const [remoI18n] = useState(RemoI18n.getInstance);
    const language = useValueEnhancer(remoI18n.$Val.language$);
    return useCallback<RemoI18nTFunction>(
        (key, options) => remoI18n.t(key, options),
        // update tFunction when language changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [remoI18n, language],
    );
}
